import React from 'react'
import ImageWithBasePath from '../components/ImageWithBasePath'
import { Tag } from '../components/Tag'
import classNames from 'classnames'
import { AdvertiserSecondaryButton } from '../advertiserComponents/AdvertiserSecondaryButton'

const ImageWithContent = ({ image = '', content = '' }) => {
  return (
    <div className={'flex items-center space-x-[8px] bg-white'}>
      <ImageWithBasePath src={image} width={10} height={10} alt="content indicator" />
      <div className="w-[83.34px] truncate font-noto-sans text-[9px] font-normal leading-[14.4px] tracking-[0.01em] text-[#66676B]">
        {content}
      </div>
    </div>
  )
}

export const PreviewJobCard = ({
  cardDetals,
  mobileClassName = 'h-[263px] w-[182.19px]',
  imageName = 'desktop_blur_mobile',
  containerClassName = 'sm:mt-[32px]'
}) => {
  return (
    <div
      className={classNames(
        'relative flex w-[220px] place-content-center md:mt-[0px]',
        containerClassName
      )}
    >
      <div className={classNames('relative ', mobileClassName)}>
        <ImageWithBasePath src={imageName} alt="card background view" fill />
      </div>

      <div className="absolute left-0 top-[50px] h-fit w-[220px] bg-white shadow-cardInModal">
        <div>
          <div className="flex pt-[5px] pl-[5px] pb-[3.69px] pr-[5.5px]">
            <div className="relative">
              <ImageWithBasePath
                src={cardDetals?.logo}
                isurl={cardDetals?.isUrl}
                width={68.25}
                height={68.25}
                alt="company logo"
              />
            </div>
            <div className="absolute right-[5.5px] top-[5.5px] h-[13px] w-[13px]">
              <ImageWithBasePath src="desktop_favorite" fill alt="favorite indicator" />
            </div>
            <div className="relative pl-[7.88px]">
              <div className="flex items-center">
                <div className="max-w-[100px] truncate text-[9px] font-bold leading-[14.4px] tracking-[0.01em] text-[#2196F3] ">
                  {cardDetals?.jobRoll}
                </div>
                <div className="relative h-[10px] w-[10px]">
                  <ImageWithBasePath
                    src={'desktop_arrow_forward'}
                    alt="forward arrow symbol"
                    fill
                  />
                </div>
              </div>
              <div className="text-[9px] font-bold leading-[14.4px] tracking-[0.01em] text-[#333436] line-clamp-3 ">
                {cardDetals?.['company_name']}
              </div>
              <div className="text-[9px] font-bold leading-[14.4px] tracking-[0.01em] text-[#333436] line-clamp-3 ">
                {cardDetals?.['title']}
              </div>
              <div className="text-[9px] font-bold leading-[12.8px] tracking-[0.01em] text-[#1FAB32] ">
                {cardDetals?.salary}
              </div>
            </div>
          </div>
          <div
            id="job_tags"
            className="scrollbarHidden flex space-x-[4px] overflow-x-scroll px-[5px] pb-[7.74px]"
          >
            <Tag
              {...{
                id: '',
                title: cardDetals?.jobType,
                style: { backgroundColor: '#E9FBEC', color: '#1FAD32' },
                className: 'text-[8px] leading-[12.8px]'
              }}
            />
          </div>
          <div className="flex border-[0px] border-y-xs border-solid border-[#F1F2F6] py-[7.88px] pl-[5.27px] pr-[7.88px]">
            <div className="border-[0px] border-r-xs border-solid border-[#F1F2F6] pr-[7.88px]">
              <div>
                <ImageWithContent image="desktop_place" content={cardDetals?.location} />
              </div>
              <div>
                <ImageWithContent image="desktop_work" content={cardDetals?.experience} />
              </div>
            </div>
            <div className="pl-[5.25px]">
              <div>
                <ImageWithContent image="desktop_schedule" content={cardDetals?.jobHours} />
              </div>
              <div>
                <ImageWithContent
                  image="desktop_import_contacts"
                  content={cardDetals?.qualification}
                />
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-[7.78px] py-[5.25px] pl-[5.25px] pr-[4.75px]">
            <div className="relative h-[13px] w-[13px]">
              <ImageWithBasePath src="more_vert" fill alt="three dots icon" />
            </div>
            <div
              className={classNames(
                'flex w-full',
                cardDetals?.isWhatsPresent && 'space-x-[8.19px]'
              )}
            >
              {cardDetals?.isWhatsPresent && (
                <AdvertiserSecondaryButton
                  className="h-[26px] border-[1px] border-[#FFBB00] bg-white "
                  titleClassName="text-[9.19px] leading-[14.7px] text-[#333436]"
                  title={'Chat'}
                  icon={'desktop_whatsapp'}
                  imageDetails={{ width: 10, height: 10 }}
                />
              )}
              <AdvertiserSecondaryButton
                className="h-[26px] border-[0px] bg-secondary   "
                titleClassName="text-[9.19px] leading-[14.7px] text-[#333436]"
                title={'Call'}
                icon={'desktop_call'}
                imageDetails={{ width: 10, height: 10 }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
